import {
  Brand,
  BrandPurchaser,
  type IBrandProps,
  type IBrandPurchaserRow,
} from "@src/domain/entities/brand";
import type { IBrandRepository } from "@src/domain/repositories/brand";

export interface GetBrandDetailsResult {
  brand: Brand;
}

/**
 * Get Brand Details Use Case – fetches a single brand by id with features.
 */
export class GetBrandDetailsUseCase {
  private readonly brandRepository: IBrandRepository;

  constructor(brandRepository: IBrandRepository) {
    this.brandRepository = brandRepository;
  }

  async execute(brandId: number): Promise<GetBrandDetailsResult> {
    const { data } = await this.brandRepository.getBrandDetails(brandId);
    if (!data?.brandDetails) throw new Error("Brand not found");

    const details = data.brandDetails as IBrandProps;
    const rawPurchasers = details.brandPurchasers as
      | IBrandPurchaserRow[]
      | null
      | undefined;

    const brand = new Brand({
      ...details,
      brandPurchasers:
        rawPurchasers?.map((purchaser) =>
          purchaser instanceof BrandPurchaser
            ? purchaser
            : BrandPurchaser.from(purchaser),
        ) ?? null,
    });

    return { brand };
  }
}
